import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuSectionLink } from '../menu-section-link';
export var OnlyUserMenu = function (_a) {
    var data = _a.data;
    return (_jsx(_Fragment, { children: data.links.map(function (_a) {
            var to = _a.to, label = _a.label, icon = _a.icon, CustomLink = _a.customMenuSectionLink;
            var LinkComponent = CustomLink !== null && CustomLink !== void 0 ? CustomLink : MenuSectionLink;
            return _jsx(LinkComponent, { to: to, label: label, icon: icon }, to);
        }) }));
};
